import React, { useState } from "react";
import CertificadoDescargar from "./components/CertificadoDescargar";

export default function CertificadoListo({ datosCurso, onClose }) {
  const [mostrarDescargar, setMostrarDescargar] = useState(false);

  if (mostrarDescargar) {
    return <CertificadoDescargar 
            datosCurso={datosCurso}
            onClose={onClose}
            />;
  }

  return (
    <div className="tarjeta-certificado-listo" data-figma-id="1976:23217">
      <div className="frame-290227">
        <div className="frame-290229">
          <div className="frame-290225">
            <p className="felicidades">¡Felicidades!</p>
            <p className="t-certificado-esta-listo">
              Tu certificado está listo
            </p>
          </div>
          <p className="derivador-futuros-forwards-opciones-y-swaps">
          {datosCurso?.nombre_curso}
          </p>
          <div className="has-aprobado-77-evaluaciones-de-manera-satisfactoria">
            <p className="has-aprobado-77-evaluaciones-de-manera-satisfactoria-2">
              Has aprobado
            </p>
            <p className="has-aprobado-77-evaluaciones-de-manera-satisfactoria-3">
            {` ${datosCurso?.lecciones_completadas} `}
            </p>
            <p className="has-aprobado-77-evaluaciones-de-manera-satisfactoria-4">
              evaluaciones de manera satisfactoria.
            </p>
          </div>
        </div>
        <div className="frame-290228">
          <button className="boton-regresar-3" onClick={onClose}>
            Regresar
          </button>
          <button
            className="boton-ver-certificado"
            onClick={() => setMostrarDescargar(true)}
          >
            Ver Certificado
          </button>
        </div>
      </div>
      <img
        className="graduation-hats-amico-1"
        src="../../../images/logo.svg"
        alt="Graduation hats"
        loading="lazy"
        data-figma-id="1976:23019"
      />
    </div>
  );
}
